import React from "react";
import { getUser } from "../../utils/session";

const WelcomeBackScreen = ({ handlestart, readchapter }) => {
  // Check if operations should be disabled (security_verification_status === '1')
  const user = getUser();
  const shouldHideResumeButton = user?.security_verification_status === '1';

  return (
    <div className="entry-screen welcome-screen">
      <div className="logoText">
        <h3>Welcome Back to the <span>FTLSAE</span> Course</h3>
      </div>
      <strong className="d-block text-primary-s fw-normal py-2">
        <i className="fa fa-graduation-cap me-1"></i> Choose Wisely
      </strong>
      <br />
      <h2 className="fw-bold text-primary-s">To resume the course click Resume</h2>
      <div className="action-buttons">
        {!shouldHideResumeButton && (
          <button
            name="btn"
            onClick={handlestart}
            className="btn course-start btn-secondary-s px-4 py-3 my-4 w-100 text-white"
          >
            Resume Where I Left Off
          </button>
        )}
        <button
          name="btn"
          onClick={readchapter}
          className="btn course-start btn-primary-s px-4 py-3 my-4 w-100 text-white"
        >
          Review Completed Chapter
        </button>
      </div>

      {/* Mobile-only typography, spacing, and button size tweaks */}
      <style
        dangerouslySetInnerHTML={{
          __html: `
            @media (max-width: 767.98px) {
              .welcome-screen {
                font-size: 1rem;
                padding: 1.5rem 1.25rem;
              }
              .welcome-screen h2,
              .welcome-screen h3 {
                font-size: 1.3rem;
                margin-bottom: 0.5rem;
              }
              .welcome-screen .btn {
                padding: 0.35rem 0.6rem;
                font-size: 1rem;
                margin-top: 0.5rem;
                margin-bottom: 0.5rem;
              }
              .welcome-screen br {
                display: none;
              }
            }
          `,
        }}
      />
    </div>
  );
};

export default WelcomeBackScreen;
